import {
  Box,
  Chip,
  SxProps,
  Theme,
  Tooltip,
  TooltipProps,
} from "@mui/material";
import { NavigateToExceptionButton } from "~/components/exceptions/navigate-to-exception-button";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import { DisabledIcon, FalsePositiveIcon, WorkaroundIcon } from "~/icons";

type Props = {
  isRiskAccepted: boolean;
  isDisabled: boolean;
  isWorkaround: boolean;
  isFalsePositive: boolean;
  onPendingExceptionClick?: () => void;
  TooltipProps?: {
    title: TooltipProps["title"];
  };
};

export const ExceptionChip = ({
  isRiskAccepted,
  isDisabled,
  isWorkaround,
  isFalsePositive,
  onPendingExceptionClick,
  TooltipProps,
}: Props) => {
  const commonChipSx: SxProps<Theme> = {
    borderRadius: "4px",
    backgroundColor: "transparent",
    color: "text.secondary",
    fontSize: 12,
    fontWeight: "600",
    transition: "all 0s",
    border: (theme) => `1px solid ${theme.palette.text.secondary}`,
  };

  return (
    <Tooltip title={TooltipProps?.title} placement="top" arrow>
      <Box display="flex" alignItems="center" gap={1}>
        {isDisabled && (
          <Chip
            label="Disabled"
            icon={<DisabledIcon />}
            size="small"
            sx={commonChipSx}
            data-testid="chip-disabled"
          />
        )}
        {isRiskAccepted && (
          <Chip
            label="Risk Accepted"
            icon={<ThumbUpOffAltIcon />}
            size="small"
            sx={commonChipSx}
            data-testid="chip-risk-accepted"
          />
        )}
        {isWorkaround && (
          <Chip
            label="Workaround"
            icon={<WorkaroundIcon />}
            size="small"
            sx={commonChipSx}
            data-testid="chip-workaround"
          />
        )}
        {isFalsePositive && (
          <Chip
            label="False Positive"
            icon={<FalsePositiveIcon />}
            size="small"
            sx={commonChipSx}
            data-testid="chip-false-positive"
          />
        )}

        {onPendingExceptionClick && (
          <NavigateToExceptionButton
            onClick={(e) => {
              e.stopPropagation();
              onPendingExceptionClick?.();
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
};
